var map = {
	"./elementary": 87900,
	"./elementary.json": 87900,
	"./high": 71373,
	"./high.json": 71373,
	"./middle": 52322,
	"./middle.json": 52322,
	"./testSourseLoading/scene1": 97887,
	"./testSourseLoading/scene1.json": 97887,
	"./testSourseLoading/scene2": 50927,
	"./testSourseLoading/scene2.json": 50927,
	"./testSourseLoading/scene3": 47305,
	"./testSourseLoading/scene3.json": 47305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65016;